import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_without_properties_loose } from "@swc/helpers/_/_object_without_properties_loose";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from '@kamio/ui/components/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@kamio/ui/components/tooltip';
import { cn } from '@kamio/ui/lib/utils';
import { RotateCw as ReloadIcon } from 'lucide-react';
const ToolTipWrapper = ({ tooltip, children })=>{
    if (!tooltip) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ _jsxs(Tooltip, {
        children: [
            /*#__PURE__*/ _jsx(TooltipTrigger, {
                asChild: true,
                children: children
            }),
            /*#__PURE__*/ _jsx(TooltipContent, {
                children: /*#__PURE__*/ _jsx("p", {
                    children: tooltip
                })
            })
        ]
    });
};
export const LoadingButton = (_0)=>{
    let { isLoading, children, disabled, hideText, tooltip } = _0, props = _object_without_properties_loose(_0, [
        "isLoading",
        "children",
        "disabled",
        "hideText",
        "tooltip"
    ]);
    return /*#__PURE__*/ _jsx(ToolTipWrapper, {
        tooltip: tooltip,
        children: /*#__PURE__*/ _jsx(Button, _extends({}, props, {
            disabled: disabled || isLoading,
            "aria-disabled": disabled || isLoading,
            children: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    isLoading && /*#__PURE__*/ _jsx(ReloadIcon, {
                        className: cn('h-4 w-4 animate-spin', {
                            'mr-2': !hideText
                        })
                    }),
                    isLoading ? hideText ? null : 'Please Wait' : children
                ]
            })
        }))
    });
};
